import { TYPE } from './episodeContainer.types';

export const showEpisodeContainer = payload => ({
  type: TYPE.SHOW_EPISODE_CONTAINER,
  payload,
});

export const loadingEpisodes = payload => ({
  type: TYPE.LOADING_EPISODES,
  payload,
});

export const getEpisodes = payload => ({
  type: TYPE.GET_EPISODES,
  payload,
});

export const deletEpisode = payload => ({
  type: TYPE.DELETE_EPISODE,
  payload,
});
